import * as yup from 'yup'
import { VehicleDocumentTypeDto } from './vehicleDocumentTypeDto'

export class OCRVerificationDto {
  documentType?: VehicleDocumentTypeDto = undefined
  fileName?: string = undefined
  keyField1?: string = undefined
  keyField2?: string = undefined
  keyField3?: string = undefined
  papsNumber?: string = undefined
  brokerInvoiceNumber?: string = undefined
  bondReleaseDate?: string = undefined
  VIN?: string = undefined
  outboundTripLoadId?: string = undefined
}

export const ocrVerificationValidationSchema = yup.object<OCRVerificationDto>({
  documentType: yup.object<VehicleDocumentTypeDto>({
    vehicleTypeGuid: yup.string().required('Document Type is required.'),
    vehicleDocumentTypeId: yup.number().required('Document Type is required.'),
    name: yup.string().required('Document Type is required.'),
    specialIdentifier: yup.string().required('Document Type is required.')
  }),
  keyField1: yup.string().max(200, 'Key Field 1 cannot be more than 200 characters.').nullable(),
  keyField2: yup.string().max(200, 'Key Field 2 cannot be more than 200 characters.').nullable(),
  keyField3: yup.string().max(200, 'Key Field 3 cannot be more than 200 characters.').nullable(),
  papsNumber: yup.string().max(200, 'PAPS Number cannot be more than 200 characters.').nullable(),
  brokerInvoiceNumber: yup.string().max(200, 'Broker Invoice Number cannot be more than 200 characters.').nullable(),
  bondReleaseDate: yup.string().max(200, 'Bond Release Date cannot be more than 200 characters.').nullable(),
  VIN: yup.string().max(200, 'VIN cannot be more than 200 characters.').nullable(),
  outboundTripLoadId: yup.string().max(200, 'Outbound Trip Load ID cannot be more than 200 characters.').nullable()
})
